import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { ControlContainer, FormControl, FormGroupDirective, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { ErrorStateMatcher } from '@angular/material/core';
import { FormField } from '@app/shared/models/field.interface';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subscription } from 'rxjs';
import { FieldOption } from './../../../models/field.interface';

@Component({
  selector: 'vfs-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => SelectComponent)
    }
  ],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})
export class SelectComponent implements OnInit, OnDestroy {
  @Input() field: FormField;
  @Input() options: FieldOption[];
  @Input() errorStateMatcher: ErrorStateMatcher;
  @Input() id: any;
  @Input() value: any;
  @Input() error: string;
  @Input() multiple: boolean;
  @Input() emptyOption = false;
  @Input() searchable: boolean;
  searchValue = '';
  searchSubscription: Subscription;
  @Input() idHint: string;
  @Input() width = '220px';
  inputSearch = new FormControl();
  filteredOptions: Observable<any[]>;
  @Output() changeValue = new EventEmitter<any>();
  @Input() disabled: boolean;
  // No Form
  @Input() label?: string;
  @Input() placeholder?: string;
  @Input() hint?: string;
  @Input() formControl: FormControl;
  @Input() required: boolean;
  @Input() info?: boolean = false;
  @Input() tooltip?: string;

  @Input() ngModel: any;
  @Output() ngModelChange = new EventEmitter<any>();

  @Input() compareWith = (o1: any, o2: any) => {
    return o1 === o2;
  };

  constructor(protected translateService: TranslateService) {}

  onChange = (rating: number) => {};
  onTouched = () => {};

  writeValue(obj: any): void {
    this.value = obj;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  change(event) {
    this.changeValue.emit(event.value);
    if (this.ngModel) {
      this.ngModel = event.value;
      this.ngModelChange.emit(this.ngModel);
    }
  }

  ngOnInit() {
    this.searchSubscription = this.inputSearch.valueChanges.subscribe(value => {
      this.searchValue = this.normalize(value);
    });
  }

  generateSelectTrigger(select: MatSelect) {
    const optionsSelected = Object.entries(select.selected);

    if (optionsSelected.length > 3) {
      return `${optionsSelected.length} selected`;
    }

    return Object.entries(select.selected).map(entry => {
      return ' ' + entry[1].value;
    });
  }

  // TODO: Review this implementation
  stopPropagation(event) {
    if (event.key === ' ') {
      event.stopPropagation();
    }
  }

  public includedInSearch(option: FieldOption): boolean {
    return this.normalize(this.translateService.instant(option.label)).includes(this.searchValue);
  }

  removeFilters() {
    this.inputSearch.setValue('');
    this.searchValue = '';
  }

  openedChange(event) {
    if (!event) {
      this.removeFilters();
    }
  }

  normalize(text: string): string {
    return text
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();
  }

  ngOnDestroy() {
    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }
  }
}
